import { createFileRoute, useNavigate } from '@tanstack/react-router';
import Modal from 'components/Modal/Modal';
import CompleteView from './components/CompleteView';

export const Route = createFileRoute('/_authenticated/verification/complete')({
  component: Complete,
});

function Complete() {
  const navigate = useNavigate();

  return (
    <Modal
      hideModal={() => {}}
      content={
        <CompleteView onComplete={() => navigate({ to: '/products' })} />
      }
      show={true}
    />
  );
}

export default Complete;
